/** VM alternates, flattened for the workbook. */
import { Alternate } from "../../interfaces/Alternate";
import { User } from "../../interfaces/User";
import { formatDisplayValue } from "../utils/displayValue";

export const getAlternateCreatorIds = (alternates: Alternate[]): string[] => {
  const userIds = new Set<string>();
  for (const { created_by } of alternates) {
    if (typeof created_by === "string" && created_by.length > 0) userIds.add(created_by);
  }
  return Array.from(userIds);
};

export const transformAlternates = (
  alternates: Alternate[],
  vmCategories: Array<Record<string, any>>,
  users: User[]
): Record<string, any>[] => {
  const vmCategoryMap = new Map(vmCategories.map((cat) => [cat.id, cat.label]));
  const userMap = new Map(users.map((user) => [user.id, user.full_name]));

  return alternates.map((alt) => ({
    ...alt,
    type: formatDisplayValue(alt.type),
    status: formatDisplayValue(alt.status),
    created_by: userMap.get(alt.created_by) || alt.created_by,
    value_management_category: vmCategoryMap.get(alt.value_management_category) || alt.value_management_category,
  }));
};
